// extracted by css-extract-rspack-plugin
module.exports =  {"tooltipContent":"b8cd095dea","root":"b49911ce89"};